/* eslint-disable react/prop-types */
import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function BasicDatePicker({
  label,
  useDefaultBorders,
  onChange,
  value,
}) {
  const datePickerStyles = useDefaultBorders
    ? {}
    : {
        "& .MuiOutlinedInput-root": {
          border: "none",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "& .MuiInputBase-root": {
          borderBottom: "1px solid #BCBCBC",
          borderRadius: "0px",
        },
      };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        sx={datePickerStyles}
        onChange={onChange}
        value={value}
        slotProps={{ textField: { size: "small" } }}
        format="DD/MM/YYYY"
      />
    </LocalizationProvider>
  );
}
